<template>
  <el-table-column
    prop="count"
    label="Készlet"
    align="right"
    width="100"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.count }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'count',
};
</script>
